import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { Link } from "react-router-dom";

interface ReturnButtonProps {
  to: string;
}

const ReturnButton: React.FC<ReturnButtonProps> = ({ to }) => {
  return (
    <Box>
      <IconButton
        component={Link}
        to={to}
        color="primary"
        sx={{
          border: "1px solid",
        }}
      >
        <ArrowBack />
      </IconButton>
    </Box>
  );
};

export default ReturnButton;
